import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UIView, type UIViewInjectedProps } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_TRANSFER } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { transferStore } from '@/stores';
import { useMassUpdateCashedStores } from '@/utils/store';

import { columns } from './setup';

const entity = 'transfers';
const store = transferStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_TRANSFER, PERMISSION_CREATE]])(({ onClick }: any) => {
  return (
    <Button onClick={onClick} type="primary" icon={<FontAwesomeIcon icon={faPlus} />}>
      &nbsp;&nbsp;
      <FormattedMessage id={`${entity}.add-new`} />
    </Button>
  );
});

export const Transfers = observer(({ transition }: UIViewInjectedProps) => {
  const items = store.items;

  useMassUpdateCashedStores([store]);

  const onAdd = () => {
    transition.router.stateService.go(`base-layout.${entity}.create`);
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table rowKey="id" columns={columns} dataSource={[...items]} store={store} scroll={{ x: 1600 }} />
      <UIView />
    </>
  );
});
